import assetPath from '/app/xinglets/startpage-logged-out/entry/src/companies-section/assets/rewe-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')